import React, { Component } from "react";
import { QUESTION_IDS, ANSWER_IDS, STRINGS, UI } from "../constants";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";
import { UserDetailsService } from "../services/userDetailsService";

class Slide2_1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Advisor: [],
      errors: [],
    };
  }

  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "Slide2_1",
      step: this.props.values.step,
      requestId: this.props.values.requestId,
      medium: this.props.values.medium,
    });

    // Use centralized service to fetch user details
    UserDetailsService.fetchAndUpdateState(
      this.props.values.requestId,
      this,
      'Advisor',
      {
        componentName: "Slide2_1",
        medium: this.props.values.medium,
      }
    );
  }

  onSubmitForm = event => {
    if (this.validateForm()) {
      event.preventDefault();
      const obj2 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: ANSWER_IDS.ADVISOR_SELECTED,
        questionId: QUESTION_IDS.WHICH_ADVISOR_CHOSEN,
        responseInfo:
          this.props.values.sellerName +
          "(Sid-" +
          this.props.values.sellerId +
          ")",
        createDt: this.props.values.date,
      };

      var option2 = this.props.values.optradio1;
      if (option2 === ANSWER_IDS.OTHER_REASON) {
        var response = this.props.values.others;
      } else {
        var response = STRINGS.NA;
      }

      const obj3 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: option2,
        questionId: QUESTION_IDS.MAIN_REASON_FOR_HIRING,
        responseInfo: response,
        createDt: this.props.date,
      };
      console.log(obj2);
      console.log(obj3);
      this.props.handleSubmit2(obj2, obj3);
    }
  };

  validateForm() {
    let fields = this.props.values;
    let errors = {};
    let formIsValid = true;
    if (fields.optradio1 === "") {
      formIsValid = false;
      errors["optradio1error"] = "Kindly select an option below to proceed";
    }
    if (fields.optradio1 === ANSWER_IDS.OTHER_REASON && fields.others === "") {
      formIsValid = false;
      errors["otherserror"] = "This is a required field";
    }
    if (fields.sellerId === "") {
      formIsValid = false;
      errors["sellererror"] = "Kindly select an option below to proceed";
    }

    this.setState({
      errors: errors,
    });

    // Track validation errors if form is invalid
    if (!formIsValid) {
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
        component: "Slide2_1",
        error: "Form validation failed",
        requestId: this.props.values.requestId,
        medium: this.props.values.medium,
        step: "slide2_1_form_validation",
        validationErrors: errors,
        errorMessages: Object.values(errors),
        errorCount: Object.keys(errors).length,
      });
    }

    return formIsValid;
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };
  render() {
    const { handleInput, handleRadio, values } = this.props;

    return (
      <>
        <section className="feedback-service">
          <div className="container" style={{ textAlign: "left" }}>
            <div className="row">
              <div className="col-md-12">
                <h2>
                  Which of the advisor matches did you choose?
                  <div id="rsp_email" className="error">
                    {this.state.errors.sellererror}
                  </div>
                </h2>
                {this.state.Advisor.map(checkbox => (
                  <label className="radio-inline" key={checkbox.sellerId}>
                    <input
                      type="radio"
                      name="sellerId"
                      checked={values.sellerId === checkbox.sellerId}
                      value={checkbox.sellerNm}
                      onChange={handleRadio(checkbox.sellerId)}
                    />
                    {checkbox.sellerNm}
                  </label>
                ))}
              </div>

              <div className="col-md-12">
                <h2>
                  What was the main reason for hiring this advisor or firm?
                  <div id="rsp_email" className="error">
                    {this.state.errors.optradio1error}
                  </div>
                </h2>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="optradio1"
                    checked={values.optradio1 === ANSWER_IDS.PERSONALITY_FIT}
                    value={ANSWER_IDS.PERSONALITY_FIT}
                    onChange={handleInput(this)}
                  />
                  Personality fit
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="optradio1"
                    checked={values.optradio1 === ANSWER_IDS.YEARS_EXPERIENCE}
                    value={ANSWER_IDS.YEARS_EXPERIENCE}
                    onChange={handleInput(this)}
                  />
                  Years of experience
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="optradio1"
                    checked={values.optradio1 === ANSWER_IDS.TRACK_RECORD}
                    value={ANSWER_IDS.TRACK_RECORD}
                    onChange={handleInput(this)}
                  />
                  Successful track record
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="optradio1"
                    checked={values.optradio1 === ANSWER_IDS.EXPERTISE}
                    value={ANSWER_IDS.EXPERTISE}
                    onChange={handleInput(this)}
                  />
                  Expertise in specific services
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="optradio1"
                    checked={values.optradio1 === ANSWER_IDS.LOCATION}
                    value={ANSWER_IDS.LOCATION}
                    onChange={handleInput(this)}
                  />
                  Location
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="optradio1"
                    checked={values.optradio1 === ANSWER_IDS.OTHER_REASON}
                    value={ANSWER_IDS.OTHER_REASON}
                    onChange={handleInput(this)}
                  />
                  Other
                </label>
                <input
                  type="text"
                  className="additional"
                  placeholder="IF OTHER PLEASE SPECIFY"
                  disabled={
                    values.optradio1 !== ANSWER_IDS.OTHER_REASON
                      ? "disabled"
                      : null
                  }
                  name="others"
                  value={values.others}
                  onChange={handleInput(this)}
                ></input>
                <div id="rsp_email" className="error">
                  {this.state.errors.otherserror}
                </div>
              </div>

              <div className="col-md-3"></div>
              <div className="col-md-6">
                <input
                  type="button"
                  name="previous"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer" }}
                  value="PREVIOUS"
                  onClick={this.back}
                />
                <input
                  type="button"
                  name="next"
                  className="next btn-update action-button nextOne"
                  style={{
                    cursor: "pointer",
                    marginLeft: UI.MARGIN_LEFT,
                  }}
                  value="NEXT"
                  onClick={this.onSubmitForm}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Slide2_1;
